module.exports = __webpack_public_path__ + "marc-marmel@450x300.b252eea2.jpg";